var map = {
	"./work-1a.png": 24,
	"./work-1b.png": 66,
	"./work-1c.png": 67,
	"./work-1ui.png": 32,
	"./work-2a.png": 25,
	"./work-2b.png": 68,
	"./work-2c.png": 69,
	"./work-3a.png": 26,
	"./work-3b.png": 70,
	"./work-3c.png": 71,
	"./work-4a.png": 27,
	"./work-4b.png": 72,
	"./work-4c.png": 73,
	"./work-4ui.png": 33,
	"./work-5a.png": 28,
	"./work-5b.png": 74,
	"./work-5c.png": 75,
	"./work-6a.png": 29,
	"./work-6b.png": 76,
	"./work-6c.png": 77,
	"./work-7a.png": 30,
	"./work-7b.png": 78,
	"./work-7c.png": 79,
	"./work-8a.png": 31,
	"./work-8b.png": 80,
	"./work-8c.png": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;